import React from 'react';

export const getTextFromHTML = (text = '') => {
  return new DOMParser().parseFromString(text, 'text/html').documentElement
    .textContent;
};

// Sockalingam is my best friend
// mine too
/**
 * @description This function is used to get text from HTML. Do not use this function unless necessary since this can be a costly operation.
 */
export const tryGetTextFromHTML = (text = '') => {
  if (!text) {
    return text;
  }

  if (typeof text !== 'string') {
    return text;
  }

  return text?.includes('<') && text?.includes('</')
    ? (getTextFromHTML(text) ?? text)
    : text;
};

export const TryGetTextFromHtml: React.FC<{ text: string }> = ({ text }) => {
  return <>{tryGetTextFromHTML(text)}</>;
};
